// extracted by mini-css-extract-plugin
module.exports = {"button":"OutlineButton_button__3fl4g"};